<section class="franchise-detail-page">
  @if (loading()) {
    <p class="cg-form-help">Loading...</p>
  } @else if (detail()) {
    <div class="top-actions">
      <app-admin-button variant="secondary" type="button" routerLink="/platform/franchises">
        Back to list
      </app-admin-button>
      @if (showManage()) {
        <app-admin-button variant="primary" type="button" (click)="toggleStatus()" [disabled]="!canManage()">
          {{ detail()!.franchise.isActive ? 'Deactivate' : 'Activate' }}
        </app-admin-button>
      }
    </div>

    <div class="hero-grid">
      <app-admin-card class="identity-card">
        <div class="identity-header">
          <p class="meta-label">Franchise identity</p>
          <app-status-badge [variant]="detail()!.franchise.isActive ? 'published' : 'draft'">
            {{ detail()!.franchise.isActive ? 'Active' : 'Inactive' }}
          </app-status-badge>
        </div>
        <h3 class="identity-name">{{ detail()!.franchise.name }}</h3>
        <div class="identity-meta">
          <p><span>Franchise ID</span>{{ detail()!.franchise.franchiseId || '—' }}</p>
          <p><span>Slug / Code</span>{{ detail()!.franchise.slug }} / {{ detail()!.franchise.code }}</p>
          <p><span>Admin email</span>{{ detail()!.franchise.adminEmail }}</p>
          <p><span>Primary phone</span>{{ detail()!.franchise.contactPhone || '-' }}</p>
        </div>
      </app-admin-card>

      <app-admin-card class="metric-card">
        <span class="metric-icon"><app-admin-icon name="users" /></span>
        <p class="metric-label">Total staff</p>
        <p class="metric-value">{{ detail()!.stats.usersCount }}</p>
        <p class="metric-hint">+{{ detail()!.stats.activeCounselors }} active counselors</p>
      </app-admin-card>

      <app-admin-card class="metric-card">
        <span class="metric-icon"><app-admin-icon name="user-plus" /></span>
        <p class="metric-label">Total leads</p>
        <p class="metric-value">{{ detail()!.stats.leadsCount }}</p>
        <p class="metric-hint">Active now</p>
      </app-admin-card>
    </div>

    <div class="secondary-metrics">
      <app-admin-card class="mini-card">
        <span class="mini-icon"><app-admin-icon name="clipboard-check" /></span>
        <div>
          <p class="mini-label">Conversion rate</p>
          <p class="mini-value">0%</p>
        </div>
      </app-admin-card>
      <app-admin-card class="mini-card">
        <span class="mini-icon mini-icon--violet"><app-admin-icon name="wallet" /></span>
        <div>
          <p class="mini-label">Monthly revenue</p>
          <p class="mini-value">$0</p>
        </div>
      </app-admin-card>
    </div>

    <app-admin-card class="panel-card">
      <div class="panel-head">
        <h3 class="panel-title"><app-admin-icon name="users" /> Staff Management</h3>
        <app-admin-button variant="secondary" type="button">Add Staff Member</app-admin-button>
      </div>
      <app-admin-table>
        <thead>
          <tr>
            <th>Name / email</th>
            <th>Role</th>
            <th>Joined date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (member of detail()!.staff; track member.id) {
            <tr>
              <td>
                <div class="staff-name-cell">
                  <span class="avatar">{{ initials(member.firstName, member.lastName, member.email) }}</span>
                  <div>
                    <p class="staff-name">{{ fullName(member.firstName, member.lastName) }}</p>
                    <p class="staff-email">{{ member.email }}</p>
                  </div>
                </div>
              </td>
              <td><code>{{ member.role }}</code></td>
              <td>{{ member.lastLoginAt ? (member.lastLoginAt | date: 'mediumDate') : '-' }}</td>
              <td>
                <app-status-badge [variant]="member.isActive ? 'published' : 'draft'">
                  {{ member.isActive ? 'Active' : 'Inactive' }}
                </app-status-badge>
              </td>
              <td class="actions-cell">...</td>
            </tr>
          }
        </tbody>
      </app-admin-table>
    </app-admin-card>

    <app-admin-card class="panel-card">
      <div class="panel-head">
        <h3 class="panel-title"><app-admin-icon name="briefcase" /> Recent Leads</h3>
        <input class="lead-filter" placeholder="Filter leads..." />
      </div>
      <app-admin-table>
        <thead>
          <tr>
            <th>Candidate name</th>
            <th>Email address</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          @if (detail()!.recentLeads.length) {
            @for (lead of detail()!.recentLeads; track lead._id) {
              <tr>
                <td>{{ lead.fullName }}</td>
                <td>{{ lead.email }}</td>
                <td>{{ lead.status }}</td>
                <td>{{ lead.createdAt | date: 'mediumDate' }}</td>
              </tr>
            }
          } @else {
            <tr>
              <td colspan="4" class="empty-leads">
                <app-admin-icon name="inbox" />
                <p>No leads recorded for this franchise yet.</p>
                <span>Leads from the home page will appear here automatically.</span>
              </td>
            </tr>
          }
        </tbody>
      </app-admin-table>
    </app-admin-card>

    <div class="cta-grid">
      <article class="gallery-card">
        <div>
          <h4>Franchise Gallery</h4>
          <p>Visual assets from this franchise location.</p>
        </div>
      </article>
      <article class="analytics-card">
        <div>
          <h4>Performance Analytics</h4>
          <p>Compare this franchise performance against regional benchmarks and enterprise KPIs.</p>
          <app-admin-button variant="secondary" type="button">View Report</app-admin-button>
        </div>
      </article>
    </div>
  } @else {
    <p class="cg-form-help">Franchise not found.</p>
  }
</section>
